@let languages = languageStore.languages;
@if (languageStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (languages() && !languageStore.isLoading()) {
  <aw-section testIdAffix="allLanguages">
    <aw-section-header>
      <aw-section-headline>
        {{ cmsTextProvider.shared.language }}
      </aw-section-headline>
      <aw-section-header-actions>
        @let hasChanges = hasUnsavedChanges(languageForm);
        <aw-reveal-form-errors-button
          [form]="languageForm"></aw-reveal-form-errors-button>
        <aw-button
          [id]="'banner-save'"
          [style]="'primary'"
          (click)="save()"
          [isDisabled]="!languageForm.valid || !hasChanges"
          [type]="'submit'"
          [text]="cmsTextProvider.shared.save">
        </aw-button>
        <aw-button
          [id]="'banner-cancel'"
          [style]="'primary-alt'"
          [type]="'reset'"
          [isDisabled]="!hasChanges"
          (click)="handleAbortChangesDialog()"
          [text]="cmsTextProvider.shared.cancel">
        </aw-button>
      </aw-section-header-actions>
    </aw-section-header>

    <aw-section
      testIdAffix="standardLanguages"
      [formGroup]="standardLanguageForm">
      <aw-section-header>
        <aw-section-headline>
          {{ cmsTextProvider.language.standardLanguage }}
        </aw-section-headline>
        <aw-section-header-actions>
          <aw-drop-down
            class="w-96"
            formControlName="standardLanguage"
            [label]="cmsTextProvider.language.standardLanguage"
            name="name"
            id="standardLanguageDropdown"
            [options]="languages() | langToOptions">
          </aw-drop-down>
        </aw-section-header-actions>
      </aw-section-header>
      <div class="flex items-center">
        {{ cmsTextProvider.language.standardLanguageExplanation }}
      </div>
    </aw-section>

    <aw-section testIdAffix="standartGermanLanguage">
      <aw-section-header>
        <aw-section-headline>
          {{ cmsTextProvider.language.german }}
        </aw-section-headline>
      </aw-section-header>
      <div class="flex items-center">
        {{ cmsTextProvider.language.germanExplanation }}
      </div>
    </aw-section>
    @for (
      languageControl of languageForm.controls.languages.controls;
      track languageControl;
      let i = $index
    ) {
      @let language = languageControl.value;
      @if (language.prefix !== 'DE' && language.prefix !== 'LS') {
        <aw-section
          [testIdAffix]="'language' | appendTestId: $index"
          [formGroup]="languageControl">
          <aw-section-header>
            <aw-section-headline>
              {{ language.name }} ({{ language.prefix }})
            </aw-section-headline>
            <aw-section-header-actions>
              @if (!language.isStandard) {
                <aw-toggle
                  formControlName="isActive"
                  [label]="cmsTextProvider.shared.setActive"
                  [id]="'languageToggle' | appendTestId: $index">
                </aw-toggle>
              }
              @if (language.isStandard) {
                <div
                  class="text-standard-text-secondary bg-standard-text-secondary/15 flex items-center gap-2 rounded-md p-2">
                  <span class="material-symbols-rounded">lock</span>
                  <span>{{ cmsTextProvider.language.standardLanguage }}</span>
                </div>
              }
            </aw-section-header-actions>
          </aw-section-header>
          <div class="flex items-center">
            {{ cmsTextProvider.language.languageExplanation }}
          </div>
          <div class="flex items-center gap-4">
            {{ cmsTextProvider.language.translationStatus }}
            <div
              class="h-2 w-full max-w-md overflow-hidden rounded-full bg-gray-300">
              <div
                [style.width]="
                  language.prefix ? percentage(language.prefix) : ''
                "
                class="h-full animate-[progress_2s_infinite_alternate_ease-in-out] bg-black"></div>
            </div>
          </div>
          @if (!language.isStandard) {
            <div class="mt-4 flex justify-end gap-2">
              <aw-button
                [id]="'edit-language' | appendTestId: $index"
                [type]="'button'"
                (click)="handleEditLanguageDialog(i)"
                [style]="'primary-alt'">
                <span class="material-symbols-rounded">edit</span>
              </aw-button>
              <aw-button
                [id]="'delete-language' | appendTestId: $index"
                [type]="'button'"
                (click)="handleDeleteLanguage(i)"
                [style]="'error-alt'">
                <span class="material-symbols-rounded">delete</span>
              </aw-button>
            </div>
          }
        </aw-section>
      }
    }

    <div class="flex flex-row justify-end">
      <aw-button
        class="w-full"
        [id]="'add-logo'"
        [type]="'button'"
        (click)="handleAddLanguageDialog()"
        [style]="'primary-alt'"
        [text]="cmsTextProvider.language.addLanguage">
        <span class="material-symbols-rounded"> add </span>
      </aw-button>
    </div>
  </aw-section>
}
